/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const o="esri-navigation-toggle",t={base:o,isLayoutHorizontal:`${o}--horizontal`};export{t as css};
